<!--
  @author:chen.hao
  @time:2018/11/25
  @disc:组织管理
 -->

<template>
  <div class="organization-manager">
    <el-input
      placeholder="输入关键字进行过滤"
      v-model="filterText"
      suffix-icon="el-icon-search"
      class="search-input">
    </el-input>
    <el-tree
      accordion
      ref="tree"
      class="org-tree"
      node-key="id"
      :data="tree"
      :props="defaultProps"
      :default-expanded-keys="expandedKeys"
      :filter-node-method="handleFilter"
      @node-expand="handleExpand"
      @node-collapse="handleCollapse">
       <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span class="item-action">
          <el-button
            v-if="data.usType === 1"
            v-permission="'0010101'"
            type="text"
            @click.stop="handleAdd(node,data)">
            <i class="el-icon-circle-plus-outline"></i>
          </el-button>
          <el-button
            v-if="data.parentId"
            v-permission="'0010103'"
            type="text"
            @click.stop="handleEdit(node,data)">
            <i class="el-icon-edit"></i>
          </el-button>
          <el-button
            v-if="ifDelete(data)"
            v-permission="'0010104'"
            type="text"
            @click.stop="handleDelete(data)">
            <i class="el-icon-delete"></i>
          </el-button>
        </span>
      </span>
    </el-tree>
    <add-or-edit-dialog :show.sync="dialogVisible" :info="dialogInfo"></add-or-edit-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AddOrEditDialog from './addOrEditDialog'
export default {
  name: 'organizationManager',
  components: { AddOrEditDialog },
  data () {
    return {
      form: {
        userPhone: ''
      },
      defaultProps: {
        children: 'child',
        label: 'deptName'
      },
      expandedKeys: [],
      dialogVisible: false,
      dialogInfo: '',
      filterText: ''
    }
  },
  computed: {
    ...mapGetters({
      tree: 'getOrgTree'
    })
  },
  methods: {
    ...mapActions(['getOrgTree', 'deleteOrg']),
    handleDelete (data) {
      this.$confirm('是否确认删除', '删除提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.deleteOrg({ id: data.id, orgType: data.orgType })
        this.getOrgTree()
      })
        .catch(() => {})
    },
    handleAdd (node, data) {
      node.expanded = true
      this.expandedKeys.push(data.id) // 树重新加载后展开形式不变
      this.dialogVisible = true
      this.dialogInfo = {
        parentName: data.deptName,
        parentId: data.id,
        orgType: data.orgType,
        usType: data.parentId ? 2 : 1// 一级根节点只能添加组织，二级组织只能添加部门
      }
    },
    handleEdit (node, data) {
      this.dialogVisible = true
      this.dialogInfo = {
        ...data,
        parentName: node.parent.data.deptName
      }
    },
    // 设置增删改操作后树重新加载列表后的默认展开节点
    handleExpand (data) {
      this.expandedKeys.push(data.id)
    },
    handleCollapse (data) {
      this.$lodash.pull(this.expandedKeys, data.id)
    },
    handleFilter (value, data) {
      if (!value) return true
      return data.deptName.indexOf(value) !== -1
    },
    // 有子部门及经营组织不允许删除
    ifDelete (data) {
      if (data.orgType === 1 && data.usType === 1) {
        return false
      } else if (data.child) {
        return false
      } else {
        return true
      }
    }
  },
  mounted () {
    this.getOrgTree()
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.organization-manager {
  .org-tree {
    // width: 300px;
    .item-action {
      margin-left: 30px;
    }
  }

  .search-input {
    width: 200px;
    margin-bottom: 20px;
  }
}
</style>
